module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@2x-0e0ccc4df5fa805a5bda76026c3ab8e9.png";